import { FaCheck } from "react-icons/fa";
import { useTranslation } from "react-i18next";

const PhotoCaptureSendOverlay = ({ status }) => {
  const { t } = useTranslation();

  if (!status) {
    return null;
  }

  const isSuccess = status === "success";

  return (
    <div
      className="photo-capture-send-overlay"
      role="status"
      aria-live="polite"
      aria-busy={!isSuccess}
    >
      <div
        className={
          isSuccess
            ? "photo-capture-send-status-icon photo-capture-send-status-icon-success"
            : "photo-capture-send-status-icon photo-capture-send-status-icon-loading"
        }
        aria-hidden
      >
        {isSuccess ? (
          <FaCheck />
        ) : (
          <span className="photo-capture-send-spinner" />
        )}
      </div>
      <p className="photo-capture-send-title">
        {isSuccess
          ? t("mobile_photo_send_success_title")
          : t("mobile_photo_sending_title")}
      </p>
      <p className="photo-capture-send-message">
        {isSuccess
          ? t("mobile_photo_send_success_message")
          : t("mobile_photo_sending_message")}
      </p>
    </div>
  );
};

export default PhotoCaptureSendOverlay;
